import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useState } from "react";
import { useEffect } from "react";
import { fetchUnpaidOrders } from "../../../../../../../api";
import { Box } from "../../../../layout/box";
import { useMemo } from "react";
import CountDown from "../../../../../../components/count-down";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import AutoWidthSwiper from "../../../../../../components/swiper/autowidth";
import { IMAGE_GEEKO_LTD } from '../../../../../../../constants/index';
import { FormattedMessage } from "react-intl";


const CartUnpaidOrder =  props =>{
    useStyles(cls);
    const [unpaidOrder, setUnpaidOrder] = useState(null);

    useEffect(async () =>{
        let response = await fetchUnpaidOrders({skip: 0, limit: 1});
        if(response?.code === 200 && response?.result){
            setUnpaidOrder(response.result?.[0]);
        }
    }, []);

    const timeLeft = useMemo(() =>{
        if(unpaidOrder?.expiredPaymentTime && unpaidOrder?.serverTime){
            return unpaidOrder.expiredPaymentTime - unpaidOrder.serverTime;
        }

        return 0;
    }, [unpaidOrder]);

    const imagesArr = useMemo(() =>{
        if(unpaidOrder?.orderItems?.length > 0){
            return unpaidOrder.orderItems.map(item=>item.productImageUrl);
        }

        return [];
    }, [unpaidOrder?.orderItems]);

    const getBtnText = useMemo(() =>{
        switch(unpaidOrder?.payMethod){
            case '20':
            case '21':
            case '27':
            case '28':
            case '30':
            case '31':
            case '34':
            case '35':
            case '37':
            case '38':
            case '40':
            case '41':
            case '43':
            case '44':
                return 'Generar Ticket'
            case '29':
                return 'Gerar Ticket'
            case '16':
            case '23':
            case '25':
                return 'Imprimir boleto'
            default:
                return null
        }
    }, [unpaidOrder]);

    return <React.Fragment>
        {
            !!unpaidOrder?.id && <Box>
                <div className={cls.CartUnpaidOrder}>
                    <div className={cls.Hd}>
                        <div className={cls.Font}>
                            <span><FormattedMessage id="waiting_for_payment" defaultMessage="Waiting for payment" /></span>
                        </div>

                        <div className={cls.TimeLeft}>
                            <Iconfont className={cls.Icon}>&#xe6c3;</Iconfont>
                            <CountDown 
                                showHour 
                                offset={timeLeft} 
                                numberStyle={{color:'#e64545', fontSize:'12px'}} 
                                labelStyle={{color:'#e64545', fontSize:'12px'}}  
                                dotStyle={{color:'#e64545', fontSize:'12px'}} 
                            />
                        </div>
                    </div>

                    <div className={cls.Bd}>
                        <div className={cls.ImagesCon}>
                            <AutoWidthSwiper 
                                items={imagesArr} 
                                options={{
                                    slidesPerView: 4,
                                    spaceBetween: 5
                                }} 
                                render={(image) =>(
                                    <div className={cls.Image}>
                                        <img src={image} alt="Image" />
                                    </div>
                                )}
                            />
                        </div>

                        <div className={cls.ViewCon}>
                            <a href={getBtnText?`/user/order/detail/${unpaidOrder?.id}`:`/checkout/${unpaidOrder?.id}`}>
                                <img src={`${IMAGE_GEEKO_LTD}/chicme/2021111101/view_more.png`} alt="view_more" />
                                <span style={{wordBreak:"break-all"}}><FormattedMessage id="view" defaultMessage="view" /></span>
                            </a>
                        </div>
                    </div>
                </div>
            </Box>
        }
    </React.Fragment>
}

export default CartUnpaidOrder;